<template>
    <div class="blockIndicator">
        <ul class="indicator">
            <li v-for="(slide, index) in slideData" :class="[index+1 == currentSlide ? 'current' : '']" :key="index"
                v-on:click="toggle(index)">
                <div class="label">{{ slide.title }}</div>
                <div class="point"></div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'block_indicator',
        props: ['slideCount', 'currentSlide', 'slideData'],
        methods: {
            toggle: function(index) {
                this.$emit('switch', index + 1);
            }
        }
    }
    // change block on indicator click
</script>

<style lang="scss">
    .blockIndicator {
        position: absolute;
        top: calc(50% - 150px);
        right: 68px;
        display: flex;
        align-items: center;
        z-index: 10;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.65s $primary-ease;

        @media ($laptop-screen) {
            top: calc(50% - 120px);
        }

        @media ($mobile-screen) {
            top: calc(50% - 63px);
            right: 30px;
        }

        &.show {
            opacity: 1;
            pointer-events: all;
        }
    }

    .indicator {
        display: flex;
        flex-direction: column;
        cursor: pointer;

        li {
            margin: 10px 0;
            text-align: right;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            @media ($laptop-screen) {
                margin: 5px 0;
            }

            .label {
                @include mukta-light;
                font-size: 18px;
                display: inline-block;
                margin-right: 20px;
                opacity: 0;
                transition: all 0.65s $primary-ease;
                color: $color-yellow;
                transform: translate3d(50px, 0, 0);

                @media ($mobile-screen) {
                    display: none;
                }
            }

            .point {
                display: inline-flex;
                justify-content: center;
                align-items: center;
                width: 11px;
                height: 11px;
                position: relative;

                &:before {
                    content: '';
                    display: block;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    border: 1px solid $color-yellow;
                    transition: transform 0.65s $primary-ease;
                    box-sizing: border-box;
                    transform: scale(0, 0);
                }

                &:after {
                    content: '';
                    display: block;
                    width: 5px;
                    height: 5px;
                    border-radius: 50%;
                    background-color: #7b7b7b;
                    transition: all 0.65s $primary-ease;
                }
            }

            &:hover {
                .label {
                    opacity: 1;
                    color: $color-yellow;
                    transform: translate3d(0, 0, 0);
                }
            }

            &.current {

                .label {
                    opacity: 1;
                    transform: translate3d(0, 0, 0);
                }

                .point {

                    &:before {
                        transform: scale(1, 1);
                    }

                    &:after {
                        background-color: $color-yellow;
                        transform: scale(0, 0);
                    }
                }
            }
        }
    }
</style>
